var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(180 32 32)",
    fill: "#1B4458"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4697 22.5303C17.1768 22.2374 17.1768 21.7626 17.4697 21.4697L22.1893 16.75L8 16.75C7.58579 16.75 7.25 16.4142 7.25 16C7.25 15.5858 7.58579 15.25 8 15.25L22.1893 15.25L17.4697 10.5303C17.1768 10.2374 17.1768 9.76256 17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967L24.5303 15.4697C24.8232 15.7626 24.8232 16.2374 24.5303 16.5303L18.5303 22.5303C18.2374 22.8232 17.7626 22.8232 17.4697 22.5303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRight);
export default __webpack_public_path__ + "static/media/right-right.39332833354f4cfaa3fbeb86e65183b5.svg";
export { ForwardRef as ReactComponent };